<template>
  <div class="commentContainer " :class="isFullScreen?'fullScreen':''" @mouseover="mouseIsHover=true"
       @mouseout="mouseIsHover=false">
    <div class="containerContent">
      <perfect-scrollbar v-show="comments.length>0" :options="{suppressScrollX:true}" ref="scrollPanel">
        <div class="titlePanelView">
          <div class="leftCo">
          </div>
        </div>


        <transition name="fade">
          <div v-show="this.mustShow && comments.length>0" style="animation-duration: 1s">
            <div v-for="(comment,index) in comments" :key="comment.commentID">
              <DelayAnim :animation="false" :delay="paginationRender(index)">
                <CommentView style="animation-duration: 0.1s" :ref="comment.commentID" :weet="weet"
                             :comment="comment"/>
                <CommentAnchor :key="comment.commentID+index" :comment="comment"
                               v-for="(commentRepeat,index) in comment.repeatsComment"
                               :ref="commentRepeat.commentID"/>

              </DelayAnim>
            </div>
          </div>
        </transition>


        <div class="footer"></div>

        <infinite-loading @infinite="debouceInfinite">
          <div slot="no-more"></div>
        </infinite-loading>
      </perfect-scrollbar>
      <div class="opaqueLayoutTop">

      </div>
      <div class="opaqueLayoutBottom">

      </div>
      <div class="emptyStateLayout" v-show="comments.length===0">
        <b-loading type="is-primary" :is-full-page="false"
                   :active="!this.mustShow"></b-loading>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Weet} from '@/store/weet/weetModel';
import store from '@/store';
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import {CommentEvent} from '@/store/comment/commentModel';
import debounce from 'lodash/debounce';
import VueScrollTo from 'vue-scrollto';

import {COMMENT_TO_REPLY, GetCommentParams, LIST_COMMENT, OPEN_PANEL_REPLY} from '@/store/comment/commentAction';
import CommentView from '@/components/comment/CommentView.vue';
import MainTitle from '@/components/title/MainTitle.vue';
import WToolTip from '@/components/wrapper/w-toolTip.vue';
import WIcon from '@/components/wrapper/w-icon.vue';
import EmptyState from '@/components/layout/EmptyState.vue';
import PopUpTitle from '@/components/title/PopUpTitle.vue';
import DelayAnim from '@/components/layout/DelayAnim.vue';
import {inform} from '@/utils/dialog';
import CommentAnchor from '@/components/comment/CommentAnchor.vue';
import {Notification} from '@/store/myNotifications/myNotificationModel';
import {READ_NOTIFICATIONS} from '@/store/myNotifications/myNotificationsAction';


@Component({
  components: {
    CommentAnchor,
    DelayAnim, PopUpTitle, EmptyState, WIcon, WToolTip, MainTitle, CommentView, PerfectScrollbar
  },
})
export default class CommentPanelView extends Vue {
  @Prop()
  private weet!: Weet;
  private mustShow: boolean = false;
  private mouseIsHover: boolean = false;
  private componentInit: boolean = false;
  private scrollInprogress: boolean = false;

  private debouceInfinite = debounce((state) => {
    this.infiniteHandler(state);
  }, 250);
  private debouceScroll = debounce((withReply: boolean) => {
    this.scrollToElement(withReply);
  }, 250);


  public mounted() {
    setTimeout(() => {
      this.mustShow = true;
    }, 500);
  }


  get comments(): CommentEvent[] {
    return store.getters.getAgregateComments;
  }

  private paginationRender(index: number): number {
    // we calculate the number for the page
    const step = 10;
    const nbElementByPage = 5;
    const page = Math.floor((index / nbElementByPage)) + 1;
    return step * page;
  }


  get totalComment(): number {
    return store.getters.getTotalOfComment;
  }

  get numberOfcommentsLoaded(): number {
    return store.getters.getComments.length;
  }

  get time(): number {
    return store.getters.getTimerPlayer;
  }

  get currentPage(): number {
    return store.getters.getCurrentPageComment;
  }

  get commentToReply(): string {
    return store.getters.getCommentIDToReply;
  }

  get openPanelToReply(): string {
    return store.getters.getReplyPanelOpenID;
  }

  get isMainCommentExist(): boolean {
    if (store.getters.getCommentsForID(this.commentToReply)) {
      return true;
    } else {
      return false;
    }

  }

  get isReplyExist(): boolean {

    return store.getters.isCommentSelectedExist;
  }

  get isPlay(): boolean {
    return store.getters.isPlaying;
  }

  get isFullScreen(): boolean {
    return store.getters.isFullscreenMode;
  }

  @Watch('isPlay')
  private onPlay() {
    if (this.isPlay) {
      store.dispatch(COMMENT_TO_REPLY, '');
    }
  }


  // When finish loading
  @Watch('totalComment')
  private onTotalComment() {
    if (!this.componentInit) {
      setTimeout(() => {
        // so this is the first scroll, we can say the component is init
        this.componentInit = true;
        if (this.openPanelToReply || this.commentToReply) {
          this.debouceScroll(true);
        }
      }, 800);
    }
  }


  @Watch('openPanelToReply')
  private onForceReply() {
    if (this.openPanelToReply) {
      setTimeout(() => {
        this.debouceScroll(true);
      }, 250);
    }
  }


  @Watch('commentToReply')
  private onCommentToReplyChange() {
    if (this.commentToReply) {
      setTimeout(() => {
        this.debouceScroll(false);
      }, 250);
    }
  }

  private notificationUnreadForComment(commentID: string): Notification | undefined {
    for (const notification of store.getters.getWeetTypeUnreadNotification) {
      if (notification.commentID === commentID) {
        return notification;
      }
    }
  }

  private scrollToElement(withReply: boolean = true) {
    // if the component is not init
    if (!this.componentInit || this.scrollInprogress) {
      return;
    }

    // verification if the comment exist
    if ((withReply && !this.isReplyExist) ||
        !withReply && !this.isMainCommentExist) {
      inform(this.$t('commentPanelView.deleted').toString());
      let notif;
      if (withReply) {
        notif = this.notificationUnreadForComment(this.openPanelToReply);
      } else {
        notif = this.notificationUnreadForComment(this.commentToReply);
      }
      if (notif) {
        store.dispatch(READ_NOTIFICATIONS, [notif]);
      }
      store.dispatch(OPEN_PANEL_REPLY, '');
      store.dispatch(COMMENT_TO_REPLY, '');
      return;
    }

    if (this.commentToReply) {
      if (this.$refs[this.commentToReply]) {

        // @ts-ignore
        const panel = this.$refs.scrollPanel.$el as HTMLDivElement;

        // @ts-ignore
        let comment = this.$refs[this.commentToReply][0];

        let offset = -20;

        if (this.openPanelToReply && comment.$refs && comment.$refs[this.openPanelToReply]) {
          comment = comment.$refs[this.openPanelToReply][0];
          offset = panel.offsetHeight - comment.$el.offsetHeight - 100;
          offset = offset * -1;
        }
        if (comment.$el) {
          comment = comment.$el;
        }

        if (comment.getAttribute('linkto')) {
          // todo find better way
          // fix scroll on empty emote :
          offset = -120;
          store.dispatch(COMMENT_TO_REPLY, comment.getAttribute('linkto'));
        }

        if (comment) {
          const options = {
            container: panel,
            easing: 'ease-in-out',
            lazy: true,
            offset: offset,
            force: false,
            cancelable: true,
            onStart: (element) => {
              // scrolling started
              this.scrollInprogress = true;
            },
            onDone: (element) => {
              // scrolling is done
              this.scrollInprogress = false;
            },
            onCancel: () => {
              // scrolling has been interrupted
              this.scrollInprogress = false;
            },
            x: false,
            y: true
          };
          // we have to wait the panel is open in fullscreenmode
          this.$nextTick(() => {
            VueScrollTo.scrollTo(comment, 1000, options);
          });


        }
      }
    }
  }

  private infiniteHandler(state) {
    const paramsGetComment = new GetCommentParams(this.weet.weetID, this.currentPage + 1);
    store.dispatch(LIST_COMMENT, paramsGetComment).then(() => {
      if (this.totalComment <= this.numberOfcommentsLoaded) {
        state.complete();
      }
      state.loaded();
    }).catch(() => {
      state.complete();
    });
  }

}
</script>

<style scoped lang="scss">
@import "@/scss/shadows.scss";
@import "@/scss/gridBreakPoint.scss";

.commentContainer {
  height: 100%;

  .titlePanelView {
    display: flex;
    align-items: center;
    margin-top: 16px;

    .leftCo {

      font-weight: 900;
      font-size: 14px;
      color: var(--dark);
      text-align: left;
      padding-left: 16px;
      text-transform: uppercase;
      flex: 1;
    }

  }


  .emptyStateLayout {
    position: relative;
    width: 100%;
    min-height: 300px;
  }

  .containerContent {
    height: 100%;
    position: relative;

    .opaqueLayoutTop {
      width: 100%;
      height: 40px;
      pointer-events: none;
      position: absolute;
      top: -4px;
      background: linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
    }

    .opaqueLayoutBottom {
      width: 100%;
      height: 40px;
      pointer-events: none;
      position: absolute;
      bottom: 0px;
      background: linear-gradient(rgba(255, 255, 255, 0.0), rgba(255, 255, 255, 1));
      @include GRID1X {
        display: none;
      }
      // background: red;
    }

    .ps {
      max-width: 400px;
      max-height: calc(100vh - 340px);
      padding-right: 16px;
      padding-bottom: 32px;
      min-height: 320px;
      @include GRID1X {
        padding-right: 0px;
      }
    }

    .footer {
      height: 150px;
      background: rgba(0, 0, 0, 0);
    }

    .emptyState {
      .iconEmptyStateContainer {
        margin-top: 120px;
      }

      .labelEmptyState {
        color: var(--light2);
        margin-top: 24px;
        margin-left: 32px;
        margin-right: 32px;
        max-width: 320px;
      }
    }
  }

  &.fullScreen {
    .ps {
      max-height: calc(100vh - 190px);
    }
  }
}

</style>
